module.exports = {
    doublegame: {
        background: 'res/doublegame_background.jpg',
        
        currentWinLabel:{
            position:{x:266, y:112},
            font:'doublegame_win_font',
            align:'center'
        },

        nextWinLabel:{
            position:{x:743, y:112},
            font:'doublegame_next_win_font',
            align:'center'
        },

        selectLabel:{
            redPosition:{x:246, y:540},
            blackPosition:{x:788, y:540},
            image:'select.png'
        },

        playerWinsLabel:{
            position:{x:512, y:100},
            image:'player_wins.png'
        },

        playerLoseLabel:{
            position:{x:512, y:100},
            image:'player_lose.png'
        },

        centralCard: {
            position:{x:512, y:310},
            neutralShirt:'neutral_shirt.png',
            redShirt:'red_shirt.png',
            blackShirt:'black_shirt.png'
        },

        suits:{
            diamonds:'diamonds.png',
            hearts:'hearts.png',
            spades:'spades.png',
            clubs:'clubs.png'
        },

        history:{
            length:5,
            position:{x:555, y:168},
            cardOffset:90,
            cardScale:0.45
        },

        redButton:{
            position:{x:246, y:353},
            hitArea:'ellipse',
            state:{
                normal:'button_red_normal.png',
                over:'button_red_over.png',
                pressed:'button_red_pressed.png',
                disabled:'button_red_disabled.png'
            }
        },

        blackButton:{
            position:{x:788, y:353},
            hitArea:'ellipse',
            state:{
                normal:'button_black_normal.png',
                over:'button_black_over.png',
                pressed:'button_black_pressed.png',
                disabled:'button_black_disabled.png'
            }
        },

        collectButton:{
            position:{x:872, y:615}
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 40
// module chunks = 0